export default (str: string) => str.split('?')[0]
